/* kd-badges.js — Kanadeal : bandeau de réassurance mobile en défilement automatique
   - Réunit les 4 cartes (réparties sur 2 sections) en une seule rangée
   - Met chaque carte à l'horizontale (icône à gauche, titre à droite, description sous le titre)
   - Fait défiler la rangée vers la gauche en boucle
   - Mobile uniquement (<= 749px). Ne touche pas au bloc d'avis, ni aux sections desktop.
*/
(function () {
  var MQ = window.matchMedia('(max-width: 749px)');
  // Couples [hôte (reçoit la rangée), donneur (contient 2 cartes + avis)] identifiés par les clés de section
  var PAIRS = [
    { host: 'pmWTQT', donor: 'aHycia' }, // page d'accueil
    { host: 'ckpUmL', donor: 'WTYm6q' }  // pages collections
  ];

  function injectCSS() {
    if (document.getElementById('kd-badges-css')) return;
    var css = ''
      + '@media (max-width:749px){'
      + '.kd-marquee-viewport{overflow:hidden;}'
      + '.kd-marquee{display:flex !important;flex-wrap:nowrap !important;width:max-content !important;max-width:none !important;gap:0 !important;align-items:stretch !important;justify-content:flex-start !important;animation:kdMarqueeLeft 30s linear infinite;}'
      + '.kd-marquee:hover{animation-play-state:paused;}'
      + '.kd-marquee > .group-block{flex:0 0 auto !important;width:clamp(210px,76vw,300px) !important;margin-inline-end:12px;}'
      + '.kd-badge > .group-block-content{flex-direction:row !important;align-items:center !important;justify-content:flex-start !important;text-align:left !important;}'
      + '.kd-badge .layout-panel-flex--column{align-items:flex-start !important;text-align:left !important;}'
      + '.kd-badge .layout-panel-flex--column *{text-align:left !important;--text-align:left !important;}'
      + '}'
      + '@keyframes kdMarqueeLeft{from{transform:translateX(0);}to{transform:translateX(-50%);}}'
      + '@media (prefers-reduced-motion:reduce){.kd-marquee{animation:none !important;}}';
    var s = document.createElement('style');
    s.id = 'kd-badges-css';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function findSection(keyPart) {
    var els = document.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < els.length; i++) {
      if (els[i].id.indexOf(keyPart) !== -1) return els[i];
    }
    return null;
  }

  function wrapperOf(sectionEl) {
    return sectionEl ? sectionEl.querySelector('.section-content-wrapper') : null;
  }

  function buildPair(pair) {
    var hostSec = findSection(pair.host);
    if (!hostSec) return; // section absente sur cette page
    var hostWrap = wrapperOf(hostSec);
    if (!hostWrap || hostWrap.dataset.kdDone === '1') return;

    var donorSec = findSection(pair.donor);
    var donorWrap = wrapperOf(donorSec);

    // Cartes = enfants directs .group-block (le bloc d'avis Judge.me n'est PAS un .group-block)
    var donorCards = donorWrap ? Array.prototype.filter.call(donorWrap.children, function (c) {
      return c.classList && c.classList.contains('group-block');
    }) : [];
    var hostCards = Array.prototype.filter.call(hostWrap.children, function (c) {
      return c.classList && c.classList.contains('group-block');
    });

    // Déplacer les cartes du donneur EN TÊTE de l'hôte (ordre : certifiés, envoi, SAV, tarifs)
    for (var i = donorCards.length - 1; i >= 0; i--) {
      hostWrap.insertBefore(donorCards[i], hostWrap.firstChild);
    }

    // Liste finale des cartes uniques (dans l'ordre du DOM)
    var unique = Array.prototype.filter.call(hostWrap.children, function (c) {
      return c.classList && c.classList.contains('group-block');
    });
    if (!unique.length) return;

    // Marquer chaque carte pour la mise en page icône-à-gauche
    unique.forEach(function (c) { c.classList.add('kd-badge'); });

    // Dupliquer pour une boucle fluide (translateX -50%)
    unique.forEach(function (c) {
      var clone = c.cloneNode(true);
      clone.removeAttribute('id');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
      hostWrap.appendChild(clone);
    });

    // Activer le défilement
    var viewport = hostWrap.closest('.custom-section-content') || hostWrap.parentElement;
    if (viewport) viewport.classList.add('kd-marquee-viewport');
    hostWrap.classList.add('kd-marquee');
    hostWrap.dataset.kdDone = '1';
  }

  function run() {
    if (!MQ.matches) return;       // mobile uniquement
    injectCSS();
    PAIRS.forEach(buildPair);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Premier passage en mobile (redimensionnement) + éditeur de thème
  if (MQ.addEventListener) MQ.addEventListener('change', run);
  document.addEventListener('shopify:section:load', run);
})();
